import React, { useState } from 'react';
import { View, Text, FlatList, TextInput } from 'react-native';
import CustomPressable from '../../components/customPressable/customPressable';
import { useTranslation } from 'react-i18next';
import ReservationForm from './reservationFrom';
import EventModal from './eventModal';

const OpenSlotRestaurant = (props) => {
  const {
    getStyles,
    venuesAvailability,
    dailyProgrammeData,
    selectedTimeSlot,
    setSelectedTimeSlot,
    hasEvent,
    showExtraFields,
    setShowExtraFields,
    eventModalVisible,
    setEventModalVisible
  } = props || {};

  const {t} = useTranslation();

  const [expandedSections, setExpandedSections] = useState([]);

  const toggleSection = section => {
    setExpandedSections(prevState =>
      prevState.includes(section)
        ? prevState.filter(item => item !== section)
        : [...prevState, section],
    );
  };

  // Render each section and its corresponding time slots
  const renderItem = ({ item }) => {
    return (
      <View style={getStyles(['mainContainer'])}>
        <CustomPressable onPress={() => toggleSection(item.name)}>
          <View style={getStyles(['sectionHeader'])}>
            <Text style={getStyles(['sectionHeaderText'])}>{item.name}</Text>

            {/* Conditional rendering of event notification */}
            {hasEvent(item.shift_category) && (
              <View style={getStyles(['eventNotificationContainer'])}>
                <Text style={getStyles(['eventNotificationText'])}>
                {t('tableRes.event_period')}
                </Text>
              </View>
            )}
            <Text style={getStyles(['posAndNegTxt'])}>
              {expandedSections.includes(item.name) ? '-' : '+'}
            </Text>
          </View>
          {!expandedSections.includes(item.name) && (
            <View style={getStyles(['line'])} />
          )}
        </CustomPressable>

        {expandedSections.includes(item.name) && (
          <FlatList
            data={item.times}
            renderItem={({ item , index}) => (
              <View style={getStyles(['slotContainer'])}>
                <CustomPressable onPress={() => setSelectedTimeSlot(item)}>
                  <View style={getStyles(['radioButtonContainer'])}>
                    <View
                      style={
                        getStyles(['radioButton'])
                        // selectedTimeSlot === item && getStyles(['radioButtonSelected']),
                      }>
                      {selectedTimeSlot === item && (
                        <View style={getStyles(['radioButtonInner'])} />
                      )}
                    </View>
                    <Text style={getStyles(['openSlotListItems'])}>{item.time}</Text>
                  </View>
                </CustomPressable>
                <View style={getStyles(['scheduleLine'])} />
              </View>
            )}
            keyExtractor={(item, index) => index.toString()} 
            listKey={item => item.name}
          />
        )}
      </View>
    );
  };
  return (
    <View style={getStyles(['mainContainer'])}>
    {showExtraFields ? (
    <ReservationForm/>
  ) : (
    <>
      <Text style={getStyles(['openSlotTxt'])}>
        {t('tableRes.select_preferred')}
      </Text>

      <FlatList
        data={venuesAvailability?.availability?.filter(item => item?.times && item?.times?.length > 0)}
        renderItem={renderItem}
        keyExtractor={item => item.shift_persistent_id}
        showsVerticalScrollIndicator={false}
        scrollEnabled = {false}
      />
    </>
  )}
    <EventModal setShowExtraFields = {setShowExtraFields}  visible = {eventModalVisible} dailyProgrammeData = {dailyProgrammeData} getStyles = {getStyles} onClose ={ () => setEventModalVisible(false)}/>
    </View>
  );
};

export default OpenSlotRestaurant;
